import { routeConstants } from '../../shared/constants';
import Login from "./";

const route = {
  exact: true,
  path: routeConstants.LOGIN.route,
  component: Login
};

export default route;
